const Form066TC = {
    stepName: {
        Statement: "重要事項",
        SchoolInfo: "基本資料",
        ApplicationInfo: "署任安排詳情",
        Confirmation: "確認",
    },
    label: {
        note: "注意",
        statement: "個人資料收集聲明",
        header: {
            schoolInfo: "學校資料",
            personalInfo: "個人資料",
        },
        schoolName: "學校名稱",
        schoolCode: "學校代碼",
        schoolProgram: "授課時間",
        contactperson: "聯絡人",
        telNum: "電話號碼",

        head1: "正本：",
        head2: "教育局公積金組",
        head3: "副本：",
        contactAndTelText1: "學校聯絡人",
        contactAndTelText2: "及其電話號碼",
        contactAndTelText3: "(以便教育局處理本表格時作查詢之用)",
        ssdo: "學校所屬的教育局區域教育服務處﹝經辦人：高級學校發展主任",
        ssdo2: "﹞",
        // SSDO: "高級學校發展主任",
        sSDO: "高級學校發展主任",
        head4: "第二副本：",
        head5: "學校存檔",

        edbConfirmCheck:
            "本人謹此證實，下述教師已符合教育局通告第8/2004號所載有關署任安排的規定，亦符合資格領取較高的署任津貼，即由實職薪金與署任較高職級起薪的差額的90%提高至100%，直至",
        edbConfirmCheck2: "署任該較高職級完結為止。",
        englishName: "教師英文姓名",
        chineseName: "教師中文姓名",
        HKICNo: "香港身份證號碼",
        SRN: "員工檔號",
        rank: "實任職級",
        AppointRank: "署任職級",
        startDate: "署任期開始日期",
        effectDate: "領取100%署任津貼率的生效日期",
        endDate: "署任期完結日期",

        isLeave:
            "上述教師曾於____________(日／月／年)至____________(日／月／年)休假/缺勤連續30個曆日或以上。本人確認在計算其領取100%署任津貼率的生效日期時，已考慮教育局通告第8/2004號附錄所述有 關上述休假／缺勤對於計算首180個曆日的影響。",
        isLeave1: "上述教師曾於",
        isLeave2: "至",
        isLeave3:
            "休假/缺勤連續30個曆日或以上。本人確認在計算其領取100%署任津貼率的生效日期時，已考慮教育局通告第8/2004號附錄所述有關上述休假／缺勤對於計算首180個曆日的影響。",
        leaveStartDate: "由",
        leaveEndDate: "至",
        isConfirm:
            "本人確認在計算其領取100%署任津貼率的生效日期時，已考慮教育局通告第8/2004號附錄所述有關上述休假/缺勤對於計算首180個曆日的影響。",
        dialogBtn: "關閉",
        remindWords: "請按新計算率調整上述教師的署任津貼。",

        termsCon1: "本人已閱讀「個人資料收集聲明」及完全明白其內容。",
        termsCon2: "本人明白需透過「智方便+」帳戶以辧理申請。",
        titleOption2: {
            his: "他",
            her: "她",
        },
    },
    noteList: {
        textOne: "請在填寫前，詳細閱讀個人資料收集聲明。",
        textTwo: "請確保教師知悉所填報的內容，並已閱讀個人資料收集聲明。",
        textThree:
            "教育局將會對每份署任申請作出編制預先核查。如有關署任教師於委任日已超逾該校的核准教學人員編制，在釐清該署任安排是否符合編制人數之前，該薪金津貼將不會發放給學校。",
    },
    labelStep: [
        { step: "（a）" },
        { step: "（b）" },
        { step: "（c）" },
        { step: "（d）" },
        { step: "（e）" },
        { step: "（f）" },
        { step: "（g）" },
    ],
    certificationList: {
        text1: "教育局會利用本表格所載的個人資料，作以下其中一種或多種用途︰",
        text2: "辦理與聘用有關的事宜；",
        text3: "處理發放薪金津貼及其他政府資助；",
        text4: "計算公積金的供款；",
        text5: "進行核數工作；",
        text6: "進行研究及統計資料，以便規劃教育服務；",
        text7: "處理有關教育專業人員發展的事宜；",
        text8: "執行相關《資助則例》、《教育條例》、《教育規例》及《補助／津貼學校公積金規則》的規定。",
        text9: "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
        text10: "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局／部門／機構披露作上述用途。",
        text11: "根據《個人資料(私隱)條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
        text12: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向有關高級學校發展主任提出。",
    },
    errorMsg: {
        // lengthRule: "最大字符長度：{{max}}位",
        tel: {
            digit: "需要是8-15位",
            rule: "需要匹配電話號碼規則",
            faxRule: "需要匹配傳真號碼規則",
        },
        date: {
            effectLimit: "生效日期需在署任期内",
            leaveLimit: "此項需在署任期内",
        },
        codeDigit: "此項必須正好是{{digit}}位",
    },
};
export default Form066TC;
